import { cn } from "../../../utils/cn.js";
import { cva } from "class-variance-authority";
import * as React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Skeleton/Skeleton.tsx
const skeletonVariants = cva("animate-pulse bg-background-accent-cement-subtle", {
	defaultVariants: { radius: "sm" },
	variants: { radius: {
		full: "rounded-full",
		md: "rounded-m",
		none: "rounded-none",
		sm: "rounded-sm",
		xs: "rounded-xs"
	} }
});
/**
* Generic placeholder skeleton used to indicate loading content.
*
* Renders a pulsing block sized by the consumer via `className` (e.g.
* `h-4 w-full`). Radius defaults to `sm` (8px) but can be set to any
* design-token radius or `full` for circular/pill shapes.
*
* @param props - Standard div props plus radius variant
* @param props.radius - Border radius token applied to the skeleton block
* @param props.className - Width, height, and any layout overrides
* @returns The rendered skeleton placeholder
*/
const Skeleton = React.forwardRef(({ className, radius, ...props }, ref) => /* @__PURE__ */ jsx("div", {
	ref,
	className: cn(skeletonVariants({ radius }), className),
	...props
}));
Skeleton.displayName = "Skeleton";
//#endregion
export { Skeleton, skeletonVariants };

//# sourceMappingURL=Skeleton.js.map